import { Token } from '@uniswap/sdk-core';
import { Pool, Position } from '@uniswap/v4-sdk';
import { toJSBI } from '@/utils/bigInt';
import { assetByAddress } from '@/onchain/assets';
import { type PositionInfo } from '@/utils/types';
import { PoolState } from '@/onchain/pools';

export type GetPositionFromPositionInfoProps = {
  chainId: number | undefined;
  positionInfo: PositionInfo | undefined;
  poolState: PoolState | undefined;
};
export const getPositionFromPositionInfo = ({
  chainId,
  positionInfo,
  poolState,
}: GetPositionFromPositionInfoProps): Position | undefined => {
  if (!chainId || !positionInfo || !poolState) {
    return undefined;
  }
  const currency0 = new Token(
    chainId,
    positionInfo.poolKey.currency0,
    assetByAddress(chainId, positionInfo.poolKey.currency0)?.exponent ?? 0,
  );
  const currency1 = new Token(
    chainId,
    positionInfo.poolKey.currency1,
    assetByAddress(chainId, positionInfo.poolKey.currency1)?.exponent ?? 0,
  );
  const position: Position = new Position({
    pool: new Pool(
      currency0,
      currency1,
      positionInfo.poolKey.fee,
      positionInfo.poolKey.tickSpacing,
      positionInfo.poolKey.hooks,
      toJSBI(poolState.sqrtPriceX96),
      0,
      poolState.tick,
      [],
    ),
    tickLower: positionInfo.tickLower,
    tickUpper: positionInfo.tickUpper,
    liquidity: toJSBI(positionInfo.liquidity),
  });
  return position;
};
